var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component, Fragment, Children } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Step from './Step';
import { mapBsStyleToColor, deprecatedProp as deprecated } from './utils';
import { alloy } from './colors';
// listed from most severe to least
const stylePriority = ['danger', 'warning', 'none', 'success'];
// map of style to its priority, 0 is highest priority
const priorityMap = stylePriority.reduce((agg, curr, index) => {
    agg[curr] = index; // eslint-disable-line no-param-reassign
    return agg;
}, {});
export default class StepGroup extends Component {
    render() {
        const _a = this.props, { children, active, partial, completed, connectorColor, activeSubStep, className, style, overrideBsStyle, onClick } = _a, rest = __rest(_a, ["children", "active", "partial", "completed", "connectorColor", "activeSubStep", "className", "style", "overrideBsStyle", "onClick"]);
        let { overrideStatus } = this.props;
        // get all sub-step overrideBsStyles (Children.map can return null or undefined)
        const overrides = Children.map(children, child => child.props.overrideStatus || child.props.overrideBsStyle);
        // find the most severe style that is being passed to the sub-steps by sorting based on style priority
        const mostSevereOverride = overrides ? overrides.filter(o => o).map(o => priorityMap[o]).sort().map(p => stylePriority[p])[0] : undefined;
        if (mostSevereOverride) {
            overrideStatus = mostSevereOverride;
        }
        let renderedConnectorColor = connectorColor;
        if (completed && (overrideStatus || overrideBsStyle)) {
            renderedConnectorColor = mapBsStyleToColor(overrideStatus || overrideBsStyle, { fallback: alloy });
        }
        const stepGroupStyle = {
            borderLeft: `2px dotted ${renderedConnectorColor}`,
            margin: '4px 0 4px 9px',
            paddingLeft: '9px',
            flexDirection: 'column',
        };
        const { activeColor, small, vertical } = rest, restProps = __rest(rest, ["activeColor", "small", "vertical"]);
        return (React.createElement(Fragment, null,
            React.createElement(Step, Object.assign({}, this.props, { status: overrideStatus || overrideBsStyle, index: this.props.index.toString() }), this.props.contents),
            React.createElement("div", Object.assign({ className: className, style: Object.assign(Object.assign({}, stepGroupStyle), style) }, restProps), Children.map(children, (step, index) => {
                const controlProps = { activeColor: this.props.activeColor, small: true, vertical: true, index: `${this.props.index}.${index}` };
                if (active && activeSubStep === index) {
                    controlProps.active = true;
                    controlProps.partial = partial;
                }
                else if (completed || (active && activeSubStep > index)) {
                    controlProps.completed = true;
                }
                return React.cloneElement(step, Object.assign(Object.assign({}, controlProps), step.props));
            }))));
    }
}
StepGroup.propTypes = {
    active: PropTypes.bool,
    partial: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
    activeSubStep: PropTypes.number,
    contents: PropTypes.node,
    connectorColor: PropTypes.string,
    index: PropTypes.number,
    activeColor: PropTypes.string,
    overrideStatus: PropTypes.oneOf(stylePriority),
    children: PropTypes.node,
    style: StylePropType,
    onClick: PropTypes.func,
    overrideBsStyle: deprecated(PropTypes.oneOf(stylePriority), 'Use `overrideStatus` instead.'),
};
StepGroup.defaultProps = {
    className: '',
    index: 0,
    style: {},
};
